/**
 * <sunday-film>: the "How it's made" film (sections/sunday-m-made.liquid, mockup v88).
 * Silent; plays while at least 40% is on screen and pauses when it leaves (unless paused by hand).
 * The still (data-poster) loads only when the film is near the screen.
 * The chapter under the playhead shows over the film and is marked in the list; a chapter tap jumps there.
 */

class SundayFilm extends HTMLElement {
  connectedCallback() {
    const v = this.querySelector('video');
    const cap = this.querySelector('[data-cap]');
    const pp = this.querySelector('[data-pp]');
    const ch = [...this.querySelectorAll('[data-at]')];
    if (!v) return;
    let cur = 0;
    let held = false;
    const mark = () => {
      let i = 0;
      ch.forEach((b, j) => { if (v.currentTime >= Number(b.dataset.at) - 0.05) i = j; });
      if (i === cur) return;
      cur = i;
      if (cap) cap.textContent = ch[i].querySelector('span').textContent;
      ch.forEach((b, j) => b.setAttribute('aria-current', String(j === i)));
    };
    const paint = () => {
      pp.classList.toggle('sd-paused', v.paused);
      pp.setAttribute('aria-label', v.paused ? pp.dataset.play : pp.dataset.pause);
    };
    v.addEventListener('timeupdate', mark);
    v.addEventListener('play', paint);
    v.addEventListener('pause', paint);
    paint();
    const toggle = () => {
      if (v.paused) { held = false; v.play().catch(() => {}); } else { held = true; v.pause(); }
    };
    /* 24 Oct (AR): a tap anywhere on the film (caption and button included) plays or pauses it; the chapter list keeps its own job */
    const box = v.parentElement;
    box.addEventListener('click', toggle);
    box.style.cursor = 'pointer';
    ch.forEach((b) => b.addEventListener('click', () => {
      v.currentTime = Number(b.dataset.at) + 0.05;
      held = false;
      v.play().catch(() => {});
    }));
    // The still is fetched only when the film is near the screen, at the width it is shown (not on page load).
    if (v.dataset.poster && !v.poster) {
      const put = () => {
        const w = Math.min(1400, Math.ceil((v.clientWidth * (window.devicePixelRatio || 1)) / 200) * 200) || 1400;
        v.poster = v.dataset.poster.replace(/([?&]width=)\d+/, `$1${w}`);
      };
      const pw = v.closest('.page-wrapper');
      const root = pw && /auto|scroll/.test(getComputedStyle(pw).overflowY) ? pw : null;
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((es) => {
          if (es.some((e) => e.isIntersecting)) { io.disconnect(); put(); }
        }, { root, rootMargin: '1500px 0px' });
        io.observe(v);
      } else put();
    }
    /* AR, 24 Oct: plays with reduced motion too (silent product film) */
    new IntersectionObserver((es) => es.forEach((e) => {
      if (e.isIntersecting && e.intersectionRatio >= 0.4) { if (!held) v.play().catch(() => {}); } else v.pause();
    }), { threshold: [0, 0.4] }).observe(v);
  }
}
if (!customElements.get('sunday-film')) customElements.define('sunday-film', SundayFilm);
